import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import LanguageToggle from "@/components/LanguageToggle";
import { ArrowLeft } from "lucide-react";

const LOGOS = {
  dining: "https://customer-assets.emergentagent.com/job_3bbf64d7-5ea8-4462-b21f-8a2eab53d2ca/artifacts/z1p5466w_lama%20hummus%20logo.png",
  distribution: "https://customer-assets.emergentagent.com/job_3bbf64d7-5ea8-4462-b21f-8a2eab53d2ca/artifacts/n1pebnkt_lama%20distribution%20logo.png",
};

export default function BranchNav({ branch }) {
  const { tr } = useLang();
  const logo = LOGOS[branch];
  const location = useLocation();
  const sections =
    branch === "dining"
      ? [
          { id: "events", label: tr("nav.events") },
          { id: "menu", label: tr("dining.menuTitle") },
          { id: "story", label: tr("nav.story") },
          { id: "gallery", label: tr("nav.gallery") },
          { id: "reserve", label: tr("dining.cta") },
        ]
      : [
          { id: "pricing", label: tr("nav.pricing") },
          { id: "catalog", label: tr("nav.products") },
          { id: "collection", label: tr("nav.collection") },
          { id: "b2b", label: tr("nav.wholesale") },
        ];

  return (
    <header
      className="sticky top-0 z-40 bg-[#FDFBF7]/85 backdrop-blur border-b border-[#E5E0D8]"
      data-testid={`nav-${branch}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between gap-6">
        <Link
          to="/"
          className="flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-[#1A1A1A] hover:opacity-70 transition-opacity"
          data-testid="nav-home"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="hidden sm:inline">Lama</span>
        </Link>

        <div className="flex items-center gap-3">
          <img src={logo} alt="Lama" className="h-10 w-10 rounded-full object-cover bg-[#1A1A1A]" />
          <div className="hidden md:block leading-tight">
            <div className="font-serif text-lg text-[#1A1A1A]">
              {branch === "dining" ? "Lama Hummus" : "Lama Distribution"}
            </div>
          </div>
        </div>

        <nav className="hidden lg:flex items-center gap-6 text-[11px] uppercase tracking-[0.2em] text-[#1A1A1A]">
          {sections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className="hover:text-[#8C7A6B] transition-colors"
              data-testid={`navlink-${s.id}`}
            >
              {s.label}
            </a>
          ))}
        </nav>

        <LanguageToggle />
      </div>
    </header>
  );
}
